import type { ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormItem,
  FormMessage,
} from "@/components/base/form/hook-form";
import { Checkbox, type CheckboxBaseProps } from "../checkbox/checkbox";

export type FormCheckboxFieldProps<
  TFieldValues extends FieldValues = FieldValues,
> = {
  field: ControllerRenderProps<TFieldValues, Path<TFieldValues>>;
  label?: string;
  labelClasses?: string;
  inputClasses?: string;
  description?: string;
  className?: string;
  onChange?: (value: boolean) => void;
} & CheckboxBaseProps;

export const FormCheckboxField = <
  TFieldValues extends FieldValues = FieldValues,
>({
  description,
  field,
  className,
  inputClasses,
  onChange,
  ...props
}: FormCheckboxFieldProps<TFieldValues>) => {
  return (
    <FormItem className={className}>
      <FormControl>
        <Checkbox
          size="md"
          {...props}
          {...field}
          isSelected={field.value}
          className={inputClasses}
          onChange={(value) => {
            field.onChange(value);
            onChange?.(value);
          }}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
};

FormCheckboxField.displayName = "FormCheckboxField";
